import styled from 'styled-components';

import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const Wrapper = styled.div`
  padding: 90px 24px 0;
  h2 {
    color: ${COLOR.BLUE_1};
    position: relative;
    padding: 8px 0;
    margin-bottom: 12px;
    text-transform: initial;
    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      width: 100px;
      height: 4px;
      background: ${COLOR.GREEN_1};
    }
  }
  form {
    margin-top: 22px;
  }
  form button,
  form .MuiInputBase-root {
    width: 100%;
    margin: 5px 0;
  }
  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    padding-top: 120px;
  }
`;

export const Container = styled.div`
  max-width: 500px;
  margin: 0 auto;
`;

export const CheckBoxWrapper = styled.div`
  display: flex;
  margin: 14px 0;
  align-items: center;
  a {
    cursor: pointer;
    font-weight: 600;
    text-decoration: underline;
  }
  .MuiIconButton-root {
    width: 20px;
    height: 20px;
    margin: 10px;
  }
`;

export const Divider = styled.p`
  position: relative;
  text-align: center;
  margin: 15px 0;
  color: ${COLOR.GREY_1};
  font-size: 14px;
  &:after,
  &:before {
    position: absolute;
    top: 50%;
    content: '';
    display: block;
    width: 44%;
    height: 1px;
    background-color: ${COLOR.GREY_4};
  }
  &:after {
    left: 0;
  }
  &:before {
    right: 0;
  }
`;
